import { Component, ElementRef, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  dialogRef: MatDialogRef<any>;
  Message = false;
  submitButton = true
  constructor(
    private fb: FormBuilder,
    public router: Router,
    public umsService: UmsService,
    private elRef: ElementRef, private modalPopupService: ModalpopService,
  ) { }
  loginForm: FormGroup;

  ngOnInit(): void {
    this.Message = false;
    this.submitButton = true
    const the = localStorage.getItem('theme') ? localStorage.getItem('theme') : '';
    if (the.length <= 0) {
      this.theme('blue');
    } else {
      this.theme(the);
    }
    this.loginForm = this.fb.group({
      LoginName: ['', [Validators.required]],
      LoginEmail: ['',[Validators.required,Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]]
    });
  }

  theme(i) {
    if (i === 'white') {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', 'gray');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', 'white');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'gray');
      this.elRef.nativeElement.style.setProperty('--dark-border', 'gray');
      this.elRef.nativeElement.style.setProperty('--main-content-title', 'gray');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', 'black');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', 'black');
      localStorage.setItem('theme', i);
    } else if (i === 'yellow') {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', '#d9c8a5');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--dark-border', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--main-content-title', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', '#ffb10f');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', '#f0d6a1');
      localStorage.setItem('theme', i);
    } else if (i === 'red') {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', 'red');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', 'white');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'red');
      this.elRef.nativeElement.style.setProperty('--dark-border', 'red');
      this.elRef.nativeElement.style.setProperty('--main-content-title', 'red');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', 'red');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', 'red');
      localStorage.setItem('theme', i);
    } else if (i === 'green') {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', 'green');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', 'white');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'green');
      this.elRef.nativeElement.style.setProperty('--dark-border', 'green');
      this.elRef.nativeElement.style.setProperty('--main-content-title', 'green');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', 'green');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', 'green');
      localStorage.setItem('theme', i);
    } else {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--dark-border', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--main-content-title', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', '#7787bc');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', '#8f9cc0');
      localStorage.setItem('theme', i);
    }
  }


  Submit() {
    let payload = this.loginForm.value;
    if (payload.LoginName == '' && payload.LoginEmail == '') {
      this.loginForm.get('LoginName').markAsTouched();
      this.loginForm.get('LoginEmail').markAsTouched();
      return;
    }
    else if (payload.LoginName != '' && payload.LoginEmail == '') {
      this.loginForm.get('LoginEmail').markAsTouched();
      return;
    }
    else {
      this.onLogin();
    }
  }

  onLogin() {
    // tslint:disable-next-line:prefer-const
    let payload = this.loginForm.value;
    this.umsService.forgotPassword(payload).subscribe(res => {
      if (res.status === true) {
        this.Message = true;
        this.submitButton = false
      }
      else {
        console.log("rrrrrrrrrr",res);
        
        const  data = {};
        data['message'] = res.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.Message = false;
        this.submitButton = true
        alert(res.message);
        this.umsService.openSnackbar(res.message);
      }

    }, (ERROR: HttpErrorResponse) => {
      alert('No User Found');
      // const  data = {};
      // data['message'] = "No User Found";
      // data['title'] = 'Alert';
      // data['icon'] = 'fas fa-close';
      // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.Message = false;
      this.submitButton = true
        });
  }
  redirect(to): void {
    this.router.navigate([to]);
  }
  Back() {
    this.redirect('student-login');
  }


}
